import { useEffect, useState } from 'react';

import { primaryB, purpleB, secondaryB } from 'constants/colors';
import 'moment/locale/ru';
import { Grid, Typography, Button, IconButton, makeStyles, Avatar, Dialog, DialogTitle, DialogActions, Divider } from '@material-ui/core';

import Lightbox from 'react-image-lightbox';

import AsterEmojiTextField from 'asterX-UI/Inputs/AsterEmojiTextField';
import { NEWS_API_URL } from 'lib/api';
import axios from 'axios';
import CloseIcon from '@material-ui/icons/Close';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import AddIcon from '@material-ui/icons/Add';
import ReplyIcon from '@material-ui/icons/Reply';
import HistoryComments from './HistoryComments';
import { useLayoutEffect } from 'react';

const useStyles = makeStyles((theme) => ({
  button: {
    border: '3px solid ' + secondaryB,
    borderRadius: 10,
    display: 'flex',
    color: secondaryB,
    alignItems: 'center',
    justifyContent: 'center',
    transition: '0.3s ease-in-out',
    '&:hover': {
      backgroundColor: secondaryB,
      color: primaryB,
      borderColor: primaryB,
      cursor: 'pointer',
    },
    '&:focused': {
      backgroundColor: secondaryB,
      color: primaryB,
      borderColor: primaryB,
      cursor: 'pointer',
    },
  },
  modal: {
    borderRadius: 10,
    maxHeight: '950px !important',
    width: '100%',
    maxWidth: '600px !important',
    overflowX: 'hidden',
    zIndex: '999 !important',
  },
  root: {
    zIndex: '999 !important',
    '& .MuiBackdrop-root': {
      backdropFilter: 'blur(16px)',
      transition: 'none !important',
      backgroundColor: 'rgba(0, 0, 0, 0.6) !important',
    },
  },
}));

const CommentWall = ({ id, CW, setCommentCount, cardHeight }) => {
  const classes = useStyles();
  const [comments, setComments] = useState([]);
  const [comment, setComment] = useState();
  const [photos, setPhotos] = useState([]);
  const [open, setOpen] = useState(false);
  const [toggle, setToggle] = useState(false);
  const [sIndex, setSIndex] = useState(0);
  const [reply, setReply] = useState();
  const [loading, setLoading] = useState(false);
  const [showAllComments, setShowAllComments] = useState(false);
  const [isCommentSent, setIsCommentSent] = useState(false);

  const handleSend = () => {
    if ((!comment || !comment?.replace(/ +/g, '')?.length) && !photos?.length) {
      return;
    }
    let data = {};
    data.postId = id;
    if (!!photos.length) {
      data.attachments = photos;
    }
    if (!!comment && !!comment.replace(/ +/g, '')) {
      data.text = comment;
    }
    if (!!reply) {
      data.replyId = reply;
    }
    if (!!Object.keys(data).length) {
      setLoading(true);
      try {
        axios
          .post(NEWS_API_URL + '/comment/createComment', data, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            },
          })
          .then((r) => {
            setIsCommentSent(true);
            setPhotos([]);
            setComment();
            setReply();
            getComments();
            setShowAllComments(true);
          });
      } catch (e) {
        console.log(e);
        setLoading(false);
      }
    }
  };

  const uploadPhoto = (photo) => {
    setLoading(true);
    try {
      let formData = new FormData();
      formData.append('file', photo);
      axios
        .post(NEWS_API_URL + '/files/uploadFile', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          },
        })
        .then((res) => {
          setPhotos((prevState) => [...prevState, res.data.fileDownloadUri.toString()]);
          setLoading(false);
        });
    } catch (error) {
      setLoading(false);
      if (error.response.status === 400) {
        return;
      }
    }
    setLoading(false);
  };

  const handleCapture = (target) => {
    if (target.files) {
      if (target.files.length !== 0) {
        const file = target.files[0];
        const options = {
          maxSizeMB: 0.1,
          maxWidthOrHeight: 1920,
          useWebWorker: true,
        };
        uploadPhoto(file);
      }
    }
  };

  const handleLightBox = (state, sIndex) => {
    if (photos.length !== 0 && photos.length > sIndex) {
      setToggle(state);
      setSIndex(sIndex);
    }
  };
  const getComments = () => {
    setLoading(true);
    try {
      axios
        .get(NEWS_API_URL + '/comment/getComments/' + id, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          },
        })
        .then((r) => {
          if (!!r && !!r?.data) {
            setComments(r.data);
            setCommentCount(r.data?.length);
          }
          setLoading(false);
        });
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  useLayoutEffect(() => {
    if (isCommentSent) {
      const card = cardHeight?.current;
      const scrollPosition = card?.getBoundingClientRect().height + window?.pageYOffset - 1000;
      window?.scrollTo({
        top: scrollPosition,
        behavior: 'smooth',
      });
      setIsCommentSent(false); // сброс флага
    }
  }, [comments, isCommentSent]);

  useEffect(() => {
    getComments();
  }, []);

  return (
    <>
      <Grid item container direction={'row'} alignItems={'center'} spacing={2} style={{ marginTop: 20 }} id={'comment_bar'}>
        <HistoryComments comments={comments} setReply={setReply} CW={CW} cardHeight={cardHeight} showAllComments={showAllComments} setShowAllComments={setShowAllComments} />
        {!!reply && (
          <Grid
            item
            xs={12}
            md={12}
            container
            direction={'row'}
            alignItems={'center'}
            justifyContent={'flex-start'}
            style={{
              backgroundColor: purpleB,
              position: 'relative',
              borderTopLeftRadius: 10,
              borderTopRightRadius: 10,
              padding: 8,
            }}
          >
            <Grid item>
              <ReplyIcon style={{ height: 28, width: 28, color: primaryB, margin: 4 }} />
            </Grid>
            <Divider orientation='vertical' flexItem style={{ backgroundColor: primaryB, width: 2, marginRight: 8 }} />
            <Grid item xs={10}>
              <Grid item container xs={12} md={12}>
                <Grid item>
                  <Avatar src='/broken-image.jpg' style={{ width: '28px', height: '28px', marginRight: '8px' }} />
                </Grid>
                <Grid item>
                  <Typography variant='subtitle2' style={{ color: primaryB, marginTop: 4, marginRight: 8, fontWeight: 600 }}>
                    {comments?.find((c) => c?.id === reply)?.createdByFullname}
                  </Typography>
                </Grid>
              </Grid>
              {!!comments?.find((c) => c?.id === reply)?.attachments?.length && (
                <Grid item xs={12} md={12}>
                  <Typography variant='caption' style={{ color: primaryB, fontWeight: 500, marginLeft: 8 }}>
                    Вложение
                  </Typography>
                </Grid>
              )}
              {!!comments?.find((c) => c?.id === reply)?.text && (
                <>
                  <Grid item container direction={'row'} xs={12} md={12}>
                    <Typography variant='subtitle2' style={{ fontWeight: 500, marginLeft: 8 }}>
                      <Typography>{comments?.find((c) => c?.id === reply)?.text}</Typography>
                    </Typography>
                  </Grid>
                </>
              )}
            </Grid>
            <IconButton color={'primary'} onClick={() => setReply()} style={{ position: 'absolute', top: 0, right: 0 }}>
              <CloseIcon />
            </IconButton>
          </Grid>
        )}

        <Grid
          item
          xs={12}
          md={12}
          style={{
            backgroundColor: !!reply ? purpleB : 'transparent',
            borderBottomLeftRadius: 10,
            borderBottomRightRadius: 10,
            padding: 8,
            marginBottom: 4,
          }}
        >
          <AsterEmojiTextField
            fullWidth
            name={'comment'}
            placeholder={'Ваш комментарий'}
            value={comment || ''}
            onChange={(e) => setComment(e.target.value)}
            setValue={(e) => setComment((comment || '') + e.emoji)}
            setOpen={setOpen}
            handleSend={handleSend}
            photos={photos}
            loading={loading}
            noData={!!((!comment || !comment?.replace(/ +/g, '')?.length) && !photos?.length)}
          />
        </Grid>
      </Grid>

      <Dialog onClose={() => setOpen(false)} open={open} fullWidth classes={{ paper: classes.modal, root: classes.root }}>
        <DialogTitle>
          <Typography variant={'h6'}>Прикрепить файл</Typography>
        </DialogTitle>
        <Grid container direction={'row'} alignItems={'flex-start'} justify={'flex-start'} spacing={2} style={{ width: '100%', padding: '8px 0px', marginLeft: 0 }}>
          {photos?.map((link, i) =>
            !!(link.slice(-3) === 'png' || link.slice(-4) === 'jpeg' || link.slice(-3) === 'jpg' || link.slice(-3) === 'gif' || link.slice(-4) === 'webp') ? (
              <Grid item xs={4} md={4} style={{ position: 'relative' }}>
                <Avatar
                  variant='rounded'
                  alt='img'
                  src={link}
                  style={{
                    height: CW > 650 ? 184 : '27vw',
                    width: CW > 650 ? 184 : '27vw',
                    border: '1px solid ' + secondaryB,
                    borderRadius: 10,
                    cursor: 'pointer',
                  }}
                  onClick={(e) => handleLightBox(true, i)}
                />
                <IconButton
                  color={'primary'}
                  onClick={() => setPhotos((prevState) => [...prevState?.filter((e) => e !== link)])}
                  style={{ position: 'absolute', top: 0, right: 5 }}
                >
                  <CloseIcon />
                </IconButton>
              </Grid>
            ) : (
              <Grid item xs={4} md={4} style={{ position: 'relative' }}>
                <CloudDownloadIcon style={{ height: CW > 650 ? 184 : '27vw', width: CW > 650 ? 184 : '27vw', color: primaryB, border: '1px solid ' + secondaryB }} />
                <IconButton
                  color={'primary'}
                  onClick={() => setPhotos((prevState) => [...prevState?.filter((e) => e !== link)])}
                  style={{ position: 'absolute', top: 0, right: 5 }}
                >
                  <CloseIcon />
                </IconButton>
              </Grid>
            )
          )}
          {photos.length < 9 && (
            <Grid item xs={4} md={4}>
              <label htmlFor='icon-button-up'>
                <div className={classes.button} style={{ height: CW > 650 ? 184 : '27vw', width: CW > 650 ? 184 : '27vw' }}>
                  <AddIcon style={{ height: '35%', width: '35%' }} />
                </div>
              </label>
              <input
                multiple
                accept='image/*,.png,.jpg,.gif,.web'
                id='icon-button-up'
                type='file'
                onChange={(e) => {
                  handleCapture(e.target);
                }}
                style={{ display: 'none' }}
              />
            </Grid>
          )}
          <IconButton onClick={() => setOpen(false)} style={{ position: 'absolute', top: 12, right: 12 }}>
            <CloseIcon />
          </IconButton>
        </Grid>
        {!!photos.length && (
          <DialogActions>
            <Button color={'primary'} fullWidth variant={'contained'} size={'small'} onClick={() => setOpen(false)}>
              Прикрепить
            </Button>
          </DialogActions>
        )}
      </Dialog>

      {!!toggle && (
        <Lightbox
          mainSrc={photos[sIndex]}
          imageCaption={sIndex + 1 + '/' + photos.length}
          nextSrc={photos[(sIndex + 1) % photos.length]}
          prevSrc={photos[(sIndex + photos.length - 1) % photos.length]}
          onCloseRequest={() => {
            setToggle(false);
            setSIndex(0);
          }}
          onMovePrevRequest={() => setSIndex((sIndex + photos.length - 1) % photos.length)}
          onMoveNextRequest={() => setSIndex((sIndex + 1) % photos.length)}
        />
      )}
    </>
  );
};
export default CommentWall;
